import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import axios, { AxiosResponse } from "axios";
import {
  handleDirectDownloadResponse,
  parseDownloadErrorMessage,
} from "./download-utils";

export const downloadFirmwareBackup = async (
  namespace: string,
  sourceId: string,
  firmwareId: string,
): Promise<AxiosResponse<ArrayBuffer> | null> => {
  const baseUrl = otaUpdatesUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();
  const url =
    `${baseUrl}/api/v2/ns/${namespace}` +
    `/source/${sourceId}` +
    `/firmware-backup/${firmwareId}/download`;

  try {
    const response = await axios.get<ArrayBuffer>(url, {
      headers,
      responseType: "arraybuffer",
    });

    if (handleDirectDownloadResponse(response)) {
      return null;
    }

    return response;
  } catch (err) {
    throw new Error(
      parseDownloadErrorMessage(err, "Failed to download firmware backup."),
    );
  }
};
